import { Permission } from 'api/planning';
import { RouteDefinition } from './types';
import { OrganisationStructureLevel } from 'const';

type Routes = 'testCentreOverview';

export const getTestCentreOverviewRoutes: (basePath: string) => Record<Routes, RouteDefinition> = (
  basePath
) => ({
  testCentreOverview: {
    path: '',
    absolutePath: basePath,
    requiresAny: [Permission.ViewPlanningSession],
    filters: [
      {
        required: OrganisationStructureLevel.Centre,
      },
    ],
  },
});
